import { INSTANCE_URL, FILES_URL } from '../../Common/constant';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import { fetchAndFilterByBookMark } from '../../../actions';

export const FETCH_COMMUNITYCATEGORY = 'FETCH_COMMUNITYCATEGORY';
export const SET_FORUM_DETAILS = 'SET_FORUM_DETAILS';
export const FETCH_FORUM_DETAILS = 'FETCH_FORUM_DETAILS';
export const SHOW_ONLY_COMMUNITY_DETAILS = 'SHOW_ONLY_COMMUNITY_DETAILS';
export const FETCH_POST_COMMENT = 'FETCH_POST_COMMENT';
export const SET_POST_COMMENT = 'SET_POST_COMMENT';
export const SHOW_POST_COMMENT_MODAL = 'SHOW_POST_COMMENT_MODAL';
export const SET_POST = 'SET_POST';
export const FETCH_POST_LIKE = 'FETCH_POST_LIKE';
export const CREATE_POST_MODAL = 'CREATE_POST_MODAL';
export const FETCH_NEW_MESSAGE = 'FETCH_NEW_MESSAGE';
export const FETCH_OLD_MESSAGE = 'FETCH_OLD_MESSAGE';
export const SELECTED_COMMUNITY_DETAILS = 'SELECTED_COMMUNITY_DETAILS';

export const fetchCommunityCategory = (session, keywords = '', callback) => {
  let filter = `(eventid=${session.eventid})`;
  if (keywords != '') {
    filter += `AND(categoryname CONTAINS ${keywords})`;
  }
  filter = encodeURI(filter);

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory?filter=(${filter})&order=updatedon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_COMMUNITYCATEGORY, payload: data });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchThisCommunityCategoryDetails = (
  session,
  cateId,
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryid=${cateId})`
  );

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        callback({ success: 1, data: data.resource[0] });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const searchCommunityCategory = (session, keywords, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(categoryname CONTAINS ${keywords})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitycategory?filter=(${filter})&order=updatedon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_COMMUNITYCATEGORY, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchCommunityDetails = (session, categoryid, type, callback) => {
  //console.log('type', type);
  let filter = encodeURI(
    `(communitycategoryidfk=${categoryid})AND(eventid=${session.eventid})`
  );
  let related =
    'appuser_by_postedby,appuser_by_communitypostcomment,communitypostlike_by_communitypostidfk,appuser_by_communitypostlike';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypost?related=${related}&include_count=true&filter=(${filter})&order=updatedon%20DESC`;

  if (type == 'comment' || type == 'group') {
    let offSetQuery = `&limit=20&offset=0`;
    url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment?related=appuser_by_commentedby&filter=(${filter})&order=unixtimestamp%20DESC${offSetQuery}`;
  }

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (type == 'comment' || type == 'group') {
          dispatch({ type: FETCH_FORUM_DETAILS, payload: res });
          callback({ success: 1, data: res });
        } else {
          dispatch({
            type: FETCH_FORUM_DETAILS,
            payload: { count: res.meta.count, data: res.resource }
          });
          callback({ success: 1, data: res.resource });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearCommunityDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_FORUM_DETAILS, payload: {} });
  };
};

export const setForumDetails = values => {
  /*
    {
        viewDetails: true,
        type: category.type,
        catname: category.categoryname,
        categoryid: category.communitycategoryid,
        postadminonly: category.postadminonly
    }
  */
  return dispatch => {
    dispatch({
      type: SET_FORUM_DETAILS,
      payload: values
    });
  };
};

export const showOnlyCommunityDetails = bool => {
  return dispatch => {
    dispatch({ type: SHOW_ONLY_COMMUNITY_DETAILS, payload: bool });
  };
};

export const clearPostComment = () => {
  return dispatch => {
    dispatch({ type: FETCH_POST_COMMENT, payload: {} });
  };
};

export const setPostComment = (viewDetails = false, communitypostid = '') => {
  return dispatch => {
    dispatch({
      type: SET_POST_COMMENT,
      payload: {
        viewDetails: viewDetails,
        communitypostid: communitypostid
      }
    });
  };
};

export const fetchComments = (session, communitypostid, callback) => {
  let filter = encodeURI(
    `(communitypostidfk=${communitypostid})AND(eventid=${session.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment?related=appuser_by_commentedby&filter=(${filter})&order=createdon%20ASC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_POST_COMMENT, payload: data });
        callback({ success: 1, resource: data.resource });
      },
      error => {}
    );
  };
};

export const fetchPostLike = (session, communitypostid, callback) => {
  let filter = encodeURI(
    `(communitypostidfk=${communitypostid})AND(eventid=${session.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostlike?filter=(${filter})&order=updatedon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_POST_LIKE, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const clearPostLike = () => {
  return dispatch => {
    dispatch({ type: FETCH_POST_LIKE, payload: {} });
  };
};

export const openModalPostComment = bool => {
  return dispatch => {
    dispatch({ type: SHOW_POST_COMMENT_MODAL, payload: bool });
  };
};

export const setCategoryPost = item => {
  return dispatch => {
    dispatch({ type: SET_POST, payload: item });
  };
};

export function commentLike(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostlike`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function commentDislike(session, communitypostid, callback) {
  let filter = encodeURI(
    `(communitypostidfk=${communitypostid})AND(likedby=${session.userid})AND(eventid=${session.eventid})`
  );
  let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostlike?filter=${filter}`;
  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendChat(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export const openCreatePostModal = bool => {
  return dispatch => {
    dispatch({ type: CREATE_POST_MODAL, payload: bool });
  };
};

export function createPost(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypost`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export const fetchNewMessage = (
  session,
  categoryid,
  lastTimestamp,
  callback
) => {
  let filter = encodeURI(
    `(communitycategoryidfk=${categoryid})AND(unixtimestamp > ${lastTimestamp})AND(eventid=${session.eventid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment?related=appuser_by_commentedby&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_NEW_MESSAGE, payload: data.resource });
        callback({ success: 1, data: data.resource });
      },
      error => {}
    );
  };
};

export const fetchOlderMessage = (session, categoryid, offset, callback) => {
  let filter = encodeURI(
    `(communitycategoryidfk=${categoryid})AND(eventid=${session.eventid})`
  );
  //console.log('offset', offset);
  let offSetQuery = `&limit=20&offset=${offset}`;
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment?related=appuser_by_commentedby&filter=(${filter})&order=unixtimestamp%20DESC${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_OLD_MESSAGE, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export function uploadMedia(session, uploadFiles, callback) {
  // console.log('uploadFiles',uploadFiles);

  // let filecontent = uploadFiles.file.replace(/^data:image\/[a-z]+;base64,/, ''); // only for image type file
  let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
  // let filename = uploadFiles.name;
  let filename = `eventify/${session.eventid}/images/community/comments/${uploadFiles.name}`;

  let mediaJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: filecontent
      }
    ]
  };
  return dispatch => {
    uploadEncodedFile(
      `${FILES_URL}?check_exist=false`,
      session,
      mediaJson,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export const fetchCommunityMemberDetails = (session, cateId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryidfk=${cateId})AND(useridfk=${session.userid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitymember?related=appuser_by_useridfk&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // 'requested','accepted','removed','left','rejected' defined statuses
        if (response.metadata?.isuseradmin == 1) {
          callback({ success: 1, allow: 2, data: response.resource[0] });
        } else if (
          _.isEmpty(response.resource) ||
          response.resource[0]?.status == 'left' ||
          response.resource[0]?.status == 'rejected' ||
          response.resource[0]?.status == 'removed'
        ) {
          callback({ success: 1, allow: 0, data: response.resource[0] });
        } else {
          if (response.resource[0]?.status == 'accepted') {
            callback({ success: 1, allow: 2, data: response.resource[0] });
          } else {
            callback({ success: 1, allow: 1, data: response.resource[0] });
          }
        }
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const requestCommunityMembership = (session, value, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitymember`;
  let body = { resource: value };

  if (value.id) {
    return dispatch => {
      patchRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1, data: response.resource[0] });
        },
        error => {
          callback({ success: 0, error });
        }
      );
    };
  } else {
    return dispatch => {
      postRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  }
};

export const cancelCommunityMembership = (session, value, callback) => {
  let updateUrl = `${INSTANCE_URL}/api/v2/eventify/_table/communitymember`;
  let body = { resource: value };

  return dispatch => {
    patchRequest(
      updateUrl,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const requestCommunityFollowUnfollow = (session, dataObj, callback) => {
  let url = `${INSTANCE_URL}/api/v2/community_script`;

  return dispatch => {
    postRequest(
      url,
      dataObj,
      session,
      dispatch,
      res => {
        if (res.resource?.success == 1) {
          callback({
            success: true
          });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchCommunityFollowUnfollowStatus = (
  session,
  dataObj,
  callback
) => {
  let url = `${INSTANCE_URL}/api/v2/community_script`;
  // depending upon dataObj will get both community and post
  return dispatch => {
    postRequest(
      url,
      dataObj,
      session,
      dispatch,
      res => {
        callback({
          success: true,
          data: res.resource?.isfollowed == '1' ? true : false
        });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const selectedCommunity = (session, values, callback) => {
  return dispatch => {
    dispatch(
      fetchCommunityMemberList(session, values.communitycategoryid, res => {
        if (res.success) {
          let obj = {
            details: values,
            members: res.data,
            memberCount: res.count
          };
          dispatch({ type: SELECTED_COMMUNITY_DETAILS, payload: obj });
          callback({
            success: true,
            message: 'Successfully fetched member list'
          });
        } else {
          callback(res);
        }
      })
    );
  };
};

export const fetchCommunityMemberList = (session, cateId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryidfk=${cateId})AND(status=accepted)`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitymember?include_count=true&related=appuser_by_useridfk&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: true, count: res.meta?.count, data: res.resource });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const deleteCommunityPost = (session, postId, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypost/${postId}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteCommunityPostComment = (
  session,
  postCommentId,
  callback
) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/communitypostcomment/${postCommentId}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
